import s from './ActionsHeader.module.scss';
import Settings from '@/shared/assets/icons/settings.svg';

export const ActionsHeader = () => {
  return (
    <div className={s.ActionsHeader}>
      <Settings className={s.icon} />
    </div>
  );
};
